
import { API_URLS } from "../../constants/apiUrls";
import { commonFetch } from "../commonFetch";


// LOGIN
export const controlPanelAdminLogin = async (credentials) =>
  commonFetch(API_URLS.CONTROLPANEL_ADMIN_LOGIN_APIURL, {
    method: "POST",
    body: credentials,
    requiresAuth: true,
  });

export const StudentLogin = async (credentials) =>
  commonFetch(API_URLS.STUDENT_LOGIN_APIURL, {
    method: "POST",
    body: credentials,
    requiresAuth: true,
  });

export const EmployeeLogin = async (credentials) =>
  commonFetch(API_URLS.EMPLOYEE_LOGIN_APIURL, {
    method: "POST",
    body: credentials,
    requiresAuth: true,
  });

export const ParentLogin = async (credentials) =>
  commonFetch(API_URLS.PARENT_LOGIN_APIURL, {
    method: "POST",
    body: credentials,
    requiresAuth: true,
  });

export const login = async (credentials) =>
  commonFetch(API_URLS.AUTH_LOGIN_APIURL, {
    method: "POST",
    body: credentials,
    requiresAuth: true,
  });

// SIGNUP
export const signup = async (formData) =>
  commonFetch(API_URLS.SIGNUP_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });

// FORGOT PASSWORD

export const controlPanelAdminForgotPassword = async (formData) =>
  commonFetch(API_URLS.CONTROLPANEL_FORGOT_PASSWORD_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });

   export const studentForgotPassword = async (formData) =>
  commonFetch(API_URLS.STUDENT_FORGOT_PASSWORD_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });

// VERIFY OTP

export const controlPanelAdminVerifyOtp = async (formData) =>
  commonFetch(API_URLS.CONTROLPANEL_VERIFY_OTP_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });

  export const studentVerifyOtp = async (formData) =>
  commonFetch(API_URLS.STUDENT_VERIFY_OTP_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });